import { INSIGHT_TIMESERIES } from "constants/constantStrings";
import { LIGHT_BLUE_COLOR, ORANGE_COLOR, PINK_COLOR, PRIMARY_COLOR } from "constants/globalConstants";

export const getFIT_1_TimeSeriesConfig = [
  { title: INSIGHT_TIMESERIES.RO1_FIT_1, color: PRIMARY_COLOR, tagId: "TAG071" },
  { title: INSIGHT_TIMESERIES.RO1_P_2_RPM, color: PINK_COLOR, tagId: "TAG004" },
  { title: INSIGHT_TIMESERIES.RO1_PT_1_PV, color: ORANGE_COLOR, tagId: "TAG076" },
  { title: INSIGHT_TIMESERIES.RO1_SYSTEM_STATUS, color: LIGHT_BLUE_COLOR, tagId: "TAG001" }
];

export const getFIT_2_TimeSeriesConfig = [
  { title: INSIGHT_TIMESERIES.RO1_FIT_2_PV, color: PRIMARY_COLOR, tagId: "TAG072" },
  { title: INSIGHT_TIMESERIES.P3_RPM, color: PINK_COLOR, tagId: "TAG005" },
  { title: INSIGHT_TIMESERIES.MEMBRANE_M_DP, color: ORANGE_COLOR, tagId: "TAG038" },
  { title: INSIGHT_TIMESERIES.RO1_SYSTEM_STATUS, color: LIGHT_BLUE_COLOR, tagId: "TAG001" }
];
